
export enum BillOfMaterialsLineItemType {
    Hardware = 'Hardware',
    Product = 'Product',
    Material = 'Material'
}
    